import React from "react";
import { debounce } from "lodash";

import { TechniciansContactsListStyles } from "./styles.module";
import { TechniciansContactsListItem } from "./TechniciansContactsListItem";
import { Spinner } from "../../../components/UIKitComponents/Spinner/Spinner";
import { IconInput } from "../IconInput/IconInput";
import { TechniciansActions } from "../../../services/technicians.actions";
import { Technician as TechnicianModel } from "../../../models/Technician";
import {
  formattedPhone,
  userFriendlyPhone,
} from "../../../helpers/PhoneHelper";
import { ContactTypes } from "../../constants";
import { Contact } from "../../types";
import socketTest from "../../index";
import {
  DispatchToProps,
  StateToProps,
} from "./TechniciansContactsList.Container";

interface ITechniciansContactsListProps {
  // contacts : any;
  // searchString : string;
  // incomingCounters : any;
  // setActiveContact: ( contact : any, index : number ) => void;
  // typeSearch: ( phrase : string ) => void;
  // loadContacts: ( contacts : any[] ) => void;
}

type Props = ITechniciansContactsListProps & StateToProps & DispatchToProps;

export class TechniciansContactsList extends React.Component<Props> {
  state: any = {
    searchField: "",
    isSearchLoading: false,
  };

  constructor(props: Props) {
    super(props);
    this.onSearchTechnicians = debounce(
      this.onSearchTechnicians.bind(this),
      1000
    );
  }

  goBack() {}

  handleSelectContact(contact: any, index: number) {
    this.props.setActiveContact(contact, index);
    const cnt = new Contact(contact.original);
    socketTest.updateContact(cnt);
  }

  renderList() {
    const searchString = this.props.searchString || "";
    const incomingCounters = this.props.incomingCounters;

    return this.props.contacts
      .filter((it: any) =>
        searchString.length == 0
          ? true
          : it.name
                ?.toLowerCase()
                ?.indexOf(this.props.searchString.toLowerCase()) >= 0
            ? true
            : false
      )
      .map((it: any, index: number) => (
        <TechniciansContactsListItem
          key={index}
          contactData={it}
          incomingCounter={incomingCounters[it.original.id] || 0}
          onClick={this.handleSelectContact.bind(this, it, index)}
        />
      ));
  }

  onSearchTechnicians = (search: string) => {
    this.setState({
      isSearchLoading: true,
      searchField: search,
    });

    TechniciansActions.get(search).then((items: TechnicianModel[]) => {
      this.setSearchLoading(false);

      if (search.length === 0 && items.length === 0) {
        socketTest.requestContacts((contacts) =>
          this.props.loadContacts(contacts)
        );
      } else {
        this.props.loadContacts(
          items.map((it) => ({
            system_item_id: it.id,
            first_name: it.first_name,
            last_name: it.last_name,
            prime_member: false,
            avatar: it.avatar,
            phone: `+1${formattedPhone(it.phone)}`,
            address: "",
            type: ContactTypes.TECHNICIAN,
            original: it,
          }))
        );
      }
    });
  };

  setSearchLoading(val: boolean) {
    this.setState({
      isSearchLoading: val,
    });
  }

  render() {
    const isSearchable = this.state.searchField.length > 0;
    const isSearchLoading = this.state.isSearchLoading;
    const hasSelectedWorkspace = this.props.selectedWorkspace !== null;

    return (
      <TechniciansContactsListStyles>
        {hasSelectedWorkspace ? (
          ""
        ) : (
          <div className="cl__search">
            <div className="cl__search-wrap">
              <IconInput
                value={this.props.searchString}
                placeholder="Search"
                masked
                mask="(999) 999-9999"
                onChange={(e) => {
                  let phone = e.target.value;
                  if (phone.length === 10 && isNaN(+phone) === false) {
                    phone = userFriendlyPhone(phone);
                  }

                  this.setSearchLoading(this.props.searchString !== phone);
                  this.onSearchTechnicians(phone);
                }}
              />
            </div>

            {isSearchable ? (
              <div className="cl__search-result-space"></div>
            ) : (
              ""
            )}
            {isSearchable ? (
              <div className="cl__search-result">
                <span>SEARCH RESULTS:</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        <ul className="cl">
          {isSearchLoading ? (
            <Spinner fit color="#3333cc" size={14} margin={3} />
          ) : (
            ""
          )}
          {this.renderList.call(this)}
        </ul>
      </TechniciansContactsListStyles>
    );
  }
}
